import React from "react";
import { Box, Typography } from "@mui/material";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import HourglassTopRoundedIcon from "@mui/icons-material/HourglassTopRounded";

export const CONCLUSION_STYLES = {
  blocked: { icon: ReportProblemRoundedIcon, color: "#991b1b", accent: "#dc2626", bg: "#fef2f2" },
  review: { icon: HelpRoundedIcon, color: "#92400e", accent: "#d97706", bg: "#fffbeb" },
  clear: { icon: VerifiedRoundedIcon, color: "#166534", accent: "#16a34a", bg: "#f0fdf4" },
  pending: { icon: HourglassTopRoundedIcon, color: "#1e40af", accent: "#2563eb", bg: "#eff6ff" },
};

/** The report's conclusion line (spec 3.6) with the reasons behind it */
const ConclusionBanner = ({ conclusion, compact }) => {
  if (!conclusion) return null;
  const style = CONCLUSION_STYLES[conclusion.level] || CONCLUSION_STYLES.review;
  const Icon = style.icon;
  return (
    <Box
      role="status"
      sx={{
        display: "flex",
        gap: 1.5,
        alignItems: "flex-start",
        p: compact ? 1.5 : 2,
        borderRadius: 2,
        bgcolor: style.bg,
        borderInlineStart: `4px solid ${style.accent}`,
      }}
    >
      <Icon sx={{ color: style.accent, fontSize: compact ? 22 : 26, mt: "1px" }} />
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontWeight: 800, color: style.color, fontSize: compact ? 15 : 17 }}>
          {conclusion.title}
        </Typography>
        {conclusion.reasons?.length > 0 && (
          <Typography component="div" sx={{ color: style.color, fontSize: 13.5, mt: 0.25, opacity: 0.9 }}>
            {conclusion.reasons.join(" · ")}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ConclusionBanner;
